module.exports = __webpack_public_path__ + "static/media/logo.1437067e.png";